import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Nexus Prime Group</h1>
          <p>Your trusted partner in healthcare revenue cycle management</p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="company-overview">
        <div className="container">
          <div className="overview-content">
            <div className="overview-text">
              <h2>Who We Are</h2>
              <p>
                Nexus Solutions is a U.S.-based healthcare management company specializing in comprehensive 
                revenue cycle management (RCM) services. We are committed to helping healthcare providers 
                maximize their revenue potential while maintaining the highest standards of compliance and quality.
              </p>
              <p>
                Our team of certified professionals brings decades of experience in medical billing, 
                , coding, and revenue cycle management. 
              We also support providers with credentialing and payer enrollment to ensure they are properly contracted and ready to bill.
              We understand the complexities of healthcare 
                administration and work tirelessly to streamline processes for our clients.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Agencies Served</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">25+</div>
                <div className="stat-label">CPB Certified Billers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">AAPC Certified Coders</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">HIPAA Compliant</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founder's Message */}
      <section className="founder-message">
        <div className="container">
          <div className="founder-content">
            <div className="founder-quote">
              <blockquote>
                "I believe healthcare providers should never have to choose between quality patient care 
                and financial stability. At Nexus Solutions, we make sure they have both."
              </blockquote>
              <div className="founder-info">
                <strong>– Zain, A.Rana</strong>
                <span>(PMI-PMP, CPC, CPMA, BCHH-C)</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission */}
      <section className="mission">
        <div className="container">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>
              To provide exceptional revenue cycle management services that enable healthcare providers 
              to focus on what matters most – delivering quality patient care. We strive to be the 
              most trusted partner in healthcare administration, combining cutting-edge technology 
              with personalized service.
            </p>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="values">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Excellence</h3>
              <p>We maintain the highest standards in all our services, ensuring accuracy and efficiency in every interaction.</p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p>We conduct business with honesty, transparency, and ethical practices that build lasting trust.</p>
            </div>
            <div className="value-item">
              <h3>Innovation</h3>
              <p>We leverage advanced technology and continuous improvement to deliver cutting-edge solutions.</p>
            </div>
            <div className="value-item">
              <h3>Partnership</h3>
              <p>We work collaboratively with our clients, treating their success as our own achievement.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="certifications">
        <div className="container">
          <h2>Our Certifications</h2>
          <p>We maintain the highest industry certifications to ensure compliance and quality:</p>
          <div className="certifications-grid">
            <div className="cert-item">
              <div className="cert-icon">🏥</div>
              <h3>HIPAA Certified</h3>
              <p>100% compliant with healthcare privacy regulations</p>
            </div>
            <div className="cert-item">
              <div className="cert-icon">📋</div>
              <h3>ISO 9001-2015</h3>
              <p>Quality management system certified</p>
            </div>
            <div className="cert-item">
              <div className="cert-icon">🔒</div>
              <h3>ISO 2013</h3>
              <p>Information security management certified</p>
            </div>
            <div className="cert-item">
              <div className="cert-icon">💻</div>
              <h3>Ministry of IT</h3>
              <p>Government recognized technology standards</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose">
        <div className="container">
          <h2>Why Choose Nexus Solutions?</h2>
          <div className="choose-grid">
            <div className="choose-item">
              <h3>Expert Team</h3>
              <p>Our certified professionals bring years of experience in healthcare administration and revenue cycle management.</p>
            </div>
            <div className="choose-item">
              <h3>Advanced Technology</h3>
              <p>We utilize cutting-edge software and AI-powered tools to optimize billing processes and improve accuracy.</p>
            </div>
            <div className="choose-item">
              <h3>24/7 Support</h3>
              <p>Our dedicated team is available around the clock to address your needs and ensure seamless operations.</p>
            </div>
            <div className="choose-item">
              <h3>Proven Results</h3>
              <p>We consistently deliver measurable improvements in revenue collection and operational efficiency.</p>
            </div>
            <div className="choose-item">
              <h3>Compliance Focus</h3>
              <p>We maintain strict adherence to HIPAA, CMS, and other regulatory requirements to protect your practice.</p>
            </div>
            <div className="choose-item">
              <h3>Transparent Reporting</h3>
              <p>You'll receive detailed, real-time reports on your revenue cycle performance and key metrics.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Partner with Us?</h2>
            <p>Let's discuss how Nexus Prime Group can help optimize your revenue cycle management.</p>
            <div className="cta-actions">
              <a href="tel:6570000000" className="btn btn-primary">Call Us Now</a>
              <a href="mailto:[email]" className="btn btn-secondary">Email Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
